import {IMuWidget} from "./IMuWidget";

export class UiBulkStateChangeGroup extends IMuWidget {
	toggleAll_change() {
		this.eachTicket().map(w => w.ui.use.checked = this.ui.toggleAll.checked);
	}

	markAllByState(stateId: number) {
		this.eachTicket().map(w => w.ui.use.checked = w.stateId == stateId);
	}

	eachTicket(): UiBulkStateChangeTicket[] {
		return this.muSubWidgets.filter(w => w instanceof UiBulkStateChangeTicket) as UiBulkStateChangeTicket[];
	}
}

export class UiBulkStateChangeTicket extends IMuWidget {
	muParent: UiBulkStateChangeGroup;
	stateId: number;
	markAllByState_click() {
		this.muParent.markAllByState(this.stateId);
	}
}